import React from "react";
import "./GameTab.scss";
import { GameTabTitleComponent } from "./Constant";

// Define props type
interface GameTabProps {
  tab: number;
  setTab: (id: number) => void;
}

const GameTab: React.FC<GameTabProps> = ({ tab, setTab }) => {
  return (
    <div className="container example-one">
      <nav className="example-one-header game-tab-bar" aria-label="Game categories">
        <div className="game-tab-bar-inner">
          {GameTabTitleComponent.map((item) => (
            <button
              key={item.id}
              onClick={() => setTab(item.id)}
              className={`nav-item ${item.id === tab ? "active" : ""}`}
              aria-pressed={item.id === tab}
              aria-current={item.id === tab ? "true" : undefined}
              type="button"
            >
              {item.name}
            </button>
          ))}
        </div>
        </nav>
    </div>
  );
};

export default GameTab;
